<template>
  <div class="card p-4 shadow-sm">
    <div class="container-fluid my-4">
      <h3 class="text-center mb-4">Cambios de Habitación Pendientes</h3>

      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle">
          <thead class="bg-light text-center">
            <tr>
              <th>Reserva</th>
              <th>Cliente</th>
              <th>Fecha</th>
              <th>Habitación Anterior</th>
              <th>Nueva Habitación</th>
              <th>Motivo</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cambio in cambios" :key="cambio.IdCambioHabitacion">
              <td>R00{{ cambio.IdReserva }}</td>
              <td>{{ cambio.Nombre }} {{ cambio.Apellido }}</td>
              <td>{{ formatearFecha(cambio.Fecha) }}</td>
              <td>#{{ cambio.HabitacionAnterior }}</td>
              <td>#{{ cambio.NuevaHabitacion }}</td>
              <td>{{ cambio.Motivo }}</td>
              <td>
                <button class="btn btn-sm btn-outline-primary" @click="imprimirCambio(cambio)">
                  🖨 Imprimir
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config'

export default {
  name: 'ImprimirCambiosHabitacion',
  data() {
    return {
      cambios: []
    }
  },
  mounted() {
    this.cargarCambios();
  },
  methods: {
    async cargarCambios() {
      const res = await axios.get(`${API_URL}/cambios-habitacion/pendientes`);
      this.cambios = res.data.cambios;
    },
    formatearFecha(fecha) {
      const [year, month, day] = fecha.split('-');
      return `${year}-${month}-${day}`;
    },
    async imprimirCambio(cambio) {
      const html = `
        <html>
          <head>
            <title>Recibo de Cambio</title>
            <style>
              body {
                font-family: monospace;
                padding: 10px;
                font-size: 12px;
                width: 240px;
              }
              .line {
                margin: 4px 0;
              }
              .center {
                text-align: center;
              }
              .firma {
                margin-top: 20px;
              }
            </style>
          </head>
          <body>
            <div class="center"><strong>Cambio de habitación</strong></div>
            <div class="line"><strong>Reserva:</strong> R00${cambio.IdReserva}</div>
            <div class="line"><strong>Habitación Anterior:</strong> ${cambio.HabitacionAnterior}</div>
            <div class="line"><strong>Nueva Habitación:</strong> ${cambio.NuevaHabitacion}</div>
            <div class="line"><strong>Fecha:</strong> ${this.formatearFecha(cambio.Fecha)}</div>
            <div class="line"><strong>Huésped:</strong> ${cambio.Nombre} ${cambio.Apellido}</div>
            <div class="line"><strong>Motivo:</strong> ${cambio.Motivo}</div>

            <div class="firma">
              F. ___________________________
            </div>
          </body>
        </html>
      `;

      const ventana = window.open('', '_blank', 'width=300,height=600');
      ventana.document.open();
      ventana.document.write(html);
      ventana.document.close();

      ventana.onload = () => {
        ventana.focus();
        ventana.print();
        ventana.close();
      };
    }
  }
}
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
  text-align: center;
}
</style>
